<div class="subform">
  <mat-form-field class="full-width">
    <mat-label>Address1</mat-label>
    <input
      matInput
      name="address1"
      type="text"
      [(ngModel)]="address"
      (input)="emitAddressChange()"
      [required]="required"
    />
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Address2</mat-label>
    <input
      matInput
      name="address2"
      type="text"
      [(ngModel)]="address2"
      (input)="emitAddressChange()"
      [required]="required"
    />
  </mat-form-field>

  <div class="address-row">
    <mat-form-field class="half-width">
      <mat-label>City</mat-label>
      <input
        matInput
        name="city"
        type="text"
        [(ngModel)]="city"
        (input)="emitAddressChange()"
        [required]="required"
      />
    </mat-form-field>

    <mat-form-field class="quarter-width padded-left">
      <mat-label>State</mat-label>
      <mat-select
        [(ngModel)]="state"
        (selectionChange)="emitAddressChange()"
        name="state"
      >
        <mat-option *ngFor="let state of states" [value]="state.code">
          {{ state.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="quarter-width padded-left">
      <mat-label>Zip</mat-label>
      <input
        matInput
        name="zip"
        type="text"
        [(ngModel)]="zip"
        (input)="emitAddressChange()"
        [required]="required"
      />
    </mat-form-field>
  </div>
</div>
